import { useIdentity } from 'base/identity-resolver';
import HomepageMainContent from '../components/homepage-main-content';

const HomepageController = () => {
  const { user = {}, org = {} } = useIdentity();
  return <HomepageMainContent org={org} user={user} />;
};

export default HomepageController;
